module.exports = __webpack_public_path__ + "static/media/44.e2c844f3.png";